<template>
  <div class="shipment-item">
    <p><strong>Expéditeur :</strong> {{ shipment.sender?.contact_name }}</p>
    <p>
      <strong>Destinataire :</strong> {{ shipment.recipient?.attention_to }}
    </p>
    <!-- === Service sélectionné et frais si status created === -->
    <p
      v-if="
        (shipment.status === SHIPMENT_STATUS_CREATED ||
          shipment.status === SHIPMENT_STATUS_PICKUP_CREATED) &&
        shipment.selected_rate
      "
    >
      <strong>Service sélectionné :</strong>
      {{ shipment.selected_rate.service_name }} -
      {{ shipment.selected_rate.total.value }}
      {{ shipment.selected_rate.total.currency }}
    </p>

    <p><strong>Statut :</strong> <status-badge :status="shipment.status" /></p>

    <!-- === STATUT ESTIMATED === -->
    <div v-if="shipment.status === SHIPMENT_STATUS_ESTIMATED">
      <template v-if="!editMode">
        <p><strong>Frais disponibles :</strong></p>
        <el-select v-model="selectedService" placeholder="Choisir un service">
          <el-option
            v-for="rate in shipment.ratelist"
            :key="rate.service_id"
            :label="`${rate.service_name} - ${rate.total.value} ${rate.total.currency}`"
            :value="rate.service_id"
          />
        </el-select>

        <div class="actions">
          <el-button type="success" size="mini" @click="confirmShipment">
            Confirmer expédition
          </el-button>
          <el-button type="warning" size="mini" @click="enableEditMode">
            Modifier
          </el-button>
          <el-button
            type="danger"
            size="mini"
            @click="destroyEstimationConfirm"
          >
            Supprimer
          </el-button>
        </div>
      </template>

      <!-- Formulaire d’édition -->
      <div v-else class="mt-3">
        <shipment-form
          :shippable-id="shipment.shippable_id"
          :shippable-type="shipment.shippable_type"
          :initial-data="shipment"
          @cancel="editMode = false"
          @created="onEstimationcreated"
        />
      </div>
    </div>

    <!-- === PICKUP CREATED === -->
    <div v-if="shipment.pickup_id" class="pickup-details mb-3 mt-3">
      <el-card shadow="never" class="border border-gray-200">
        <template #header>
          <div class="flex justify-between items-center">
            <span><strong>Ramassage créé</strong></span>
            <el-tag class="ml-3" type="success" size="small"
              ><p>
                <strong>Heure prête :</strong>
                {{ formatTime(shipment.pickup_data.ready_at) }} →
                {{ formatTime(shipment.pickup_data.ready_until) }}
              </p></el-tag
            >
          </div>
        </template>

        <el-row :gutter="10">
          <el-col :span="12">
            <p><strong>Date :</strong> {{ formattedPickupDate }}</p>
            <p>
              <strong>Heure prête :</strong>
              {{ formatTime(shipment.pickup_data.ready_at) }} →
              {{ formatTime(shipment.pickup_data.ready_until) }}
            </p>
          </el-col>

          <el-col :span="12">
            <p>
              <strong>Lieu :</strong>
              {{ shipment.pickup_data.pickup_location }}
            </p>
            <p>
              <strong>Poids total :</strong>
              {{ shipment.pickup_data.package_details?.weight?.value }}
              {{ shipment.pickup_data.package_details?.weight?.unit }}
            </p>
            <p>
              <strong>Quantité de colis :</strong>
              {{ shipment.pickup_data.package_details?.quantity }}
            </p>
          </el-col>
        </el-row>

        <p class="mt-2">
          <strong>Instructions :</strong>
          {{ shipment.pickup_data.pickup_instructions || "Aucune" }}
        </p>

        <el-button type="danger" size="mini" @click="cancelPickup">
          Annuler le ramassage
        </el-button>
      </el-card>
    </div>

    <!-- === STATUT CREATED === -->
    <div
      v-if="
        (shipment.status === SHIPMENT_STATUS_CREATED ||
          shipment.status === SHIPMENT_STATUS_PICKUP_CREATED) &&
        !showPickupForm &&
        !showLabelPrint
      "
    >
      <el-button
        v-if="!shipment.pickup_id"
        type="info"
        size="mini"
        @click="openPickupForm"
      >
        Créer pickup
      </el-button>
      <el-button type="danger" size="mini" @click="cancelShipment">
        Annuler
      </el-button>
      <el-button
        type="primary"
        size="mini"
        @click="showLabelPrint = !showLabelPrint"
      >
        Etiquette
      </el-button>
    </div>

    <!-- === Impression d'étiquette === -->
    <el-card v-if="showLabelPrint" shadow="never" class="mt-3 mb-3">
      <div slot="header"><strong>Impression d'étiquette</strong></div>
      <div class="el-form-item">
        <label class="el-form-item__label" style="width: 180px"
          >Type d'étiquette</label
        >
        <div class="el-form-item__content" style="margin-left: 180px">
          <el-select
            v-model="labelType"
            placeholder="Sélectionner"
            class="mr-2"
          >
            <el-option
              v-for="lt in labelTypes"
              :key="lt"
              :label="$t('ELIXIO_CONNECT.' + lt)"
              :value="lt"
            />
          </el-select>
          <el-button type="primary" @click="printLabel">
            Imprimer étiquette
          </el-button>
        </div>
      </div>

      <!-- === Etiquette imprimée === -->
      <el-card v-if="shipment.printed_label" shadow="hover" class="mb-2">
        <div
          class="label-card-header"
          @click="openLabelLink(shipment.printed_label.shipping_label)"
          style="cursor: pointer; display: flex; align-items: center"
        >
          <span class="doc-icon mr-3"><i class="el-icon-document"></i></span>

          <span>
            <strong>
              {{
                shipment.printed_label.type
                  ? "Étiquette " +
                    $t("ELIXIO_CONNECT." + shipment.printed_label.type)
                  : "Étiquette générée"
              }}
            </strong>
            :
            <span style="color: #409eff">
              {{
                shipment.printed_label.shipping_label.slice(0, 40) +
                (shipment.printed_label.shipping_label.length > 40 ? "..." : "")
              }}
            </span>
          </span>
        </div>
      </el-card>
      <el-button
        type="danger"
        size="mini"
        @click="showLabelPrint = !showLabelPrint"
      >
        Fermer
      </el-button>
    </el-card>

    <!-- === PICKUP FORM === -->
    <div v-if="showPickupForm" class="pickup-form-wrapper">
      <pickup-form
        :shipment="shipment"
        :initial-details="pickupDefaults"
        @cancel="showPickupForm = false"
        @submitted="onPickupSubmitted"
      />
    </div>
  </div>
</template>

<script>
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Option,
  Select,
  Table,
  TableColumn,
  Tooltip,
  Card
} from "element-ui";
import { Tag, Row, Col, Drawer } from "element-ui";
import {
  PICKUP_LOCATIONS,
  LABEL_TYPES,
  LABEL_TYPE_85x11,
  SHIPMENT_STATUS_CREATED,
  SHIPMENT_STATUS_ESTIMATED,
  SHIPMENT_STATUS_PICKUP_CREATED,
  SHIPMENT_STATUS_IN_TRANSIT,
} from "../../constants/shipment";
import PickupForm from "./PickupForm.vue";
import ShipmentForm from "./ShipmentForm.vue";
import StatusBadge from "../atoms/StatusBadge.vue";

export default {
  name: "ShipmentItem",
  components: {
    PickupForm,
    ShipmentForm,
    [Col.name]: Col,
    [Row.name]: Row,
    [Tag.name]: Tag,
    [Drawer.name]: Drawer,
    StatusBadge,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    [Card.name]: Card,
  },
  props: {
    shipment: { type: Object, required: true },
  },
  data() {
    return {
      selectedService: null,
      showPickupForm: false,
      pickupDefaults: null,
      pickupLocations: PICKUP_LOCATIONS,
      editMode: false,
      showLabelPrint: this.shipment.pickup_id != null,
      labelTypes: LABEL_TYPES,
      labelType: LABEL_TYPE_85x11,
      SHIPMENT_STATUS_ESTIMATED: SHIPMENT_STATUS_ESTIMATED,
      SHIPMENT_STATUS_CREATED: SHIPMENT_STATUS_CREATED,
      SHIPMENT_STATUS_PICKUP_CREATED: SHIPMENT_STATUS_PICKUP_CREATED,
    };
  },
  computed: {
    formattedPickupDate() {
      const d = this.shipment.pickup_data?.date;
      if (!d) return "-";
      return `${d.day.toString().padStart(2, "0")}/${d.month
        .toString()
        .padStart(2, "0")}/${d.year}`;
    },
  },
  methods: {
    async confirmShipment() {
      await this.$store.dispatch("elixioConnectModule/createShipment", {
        shipmentId: this.shipment.id,
        serviceId: this.selectedService,
      });
      this.$emit("updated");
    },

    enableEditMode() {
      this.editMode = true;
    },

    async onEstimationcreated() {
      this.editMode = false;
      this.$emit("updated");
    },

    async destroyEstimationConfirm() {
      this.$confirm(
        "Êtes-vous sûr de vouloir supprimer cette estimation ?",
        "Confirmation",
        {
          confirmButtonText: "Oui, supprimer",
          cancelButtonText: "Annuler",
          type: "warning",
        }
      )
        .then(async () => {
          await this.$store.dispatch("elixioConnectModule/destroyEstimation", {
            shipmentId: this.shipment.id,
          });
          this.$emit("updated");
          this.$message.success("Estimation supprimée avec succès.");
          this.$emit("updated");
        })
        .catch(() => {});
    },

    openPickupForm() {
      const packages = this.shipment.packaging_properties?.packages || [];
      const totalWeight = packages.reduce(
        (sum, p) => sum + Number(p.weight || 0) * Number(p.quantity || 1),
        0
      );
      const totalQuantity = packages.reduce(
        (sum, p) => sum + Number(p.quantity || 1),
        0
      );

      this.pickupDefaults = {
        pickup_details: {
          date: {
            year: new Date().getFullYear(),
            month: new Date().getMonth() + 1,
            day: new Date().getDate(),
          },
          ready_at: { hour: 9, minute: 0 },
          ready_until: { hour: 17, minute: 0 },
          package_details: {
            weight: {
              unit: this.shipment.packaging_properties.weight.unit,
              value: totalWeight.toString(),
            },
            quantity: totalQuantity.toString(),
          },
          pickup_location: this.pickupLocations,
          pickup_instructions: "",
        },
      };

      this.showPickupForm = true;
    },

    async cancelShipment() {
      this.$confirm(
        "Êtes-vous sûr de vouloir annuler cette expédition ?",
        "Confirmation",
        {
          confirmButtonText: "Oui, annuler",
          cancelButtonText: "Annuler",
          type: "warning",
        }
      )
        .then(async () => {
          await this.$store.dispatch("elixioConnectModule/cancelShipment", {
            shipmentId: this.shipment.id,
          });
          this.$emit("updated");
          this.$message.success("Expédition annulée avec succès.");
        })
        .catch(() => {});
    },

    async cancelPickup() {
      this.$confirm(
        "Êtes-vous sûr de vouloir annuler le ramassage ?",
        "Confirmation",
        {
          confirmButtonText: "Oui, annuler",
          cancelButtonText: "Annuler",
          type: "warning",
        }
      )
        .then(async () => {
          await this.$store.dispatch("elixioConnectModule/cancelPickup", {
            shipmentId: this.shipment.id,
          });
          this.$emit("updated");
          this.$message.success("Ramassage annulé avec succès.");
        })
        .catch(() => {});
    },

    async printLabel() {
      const response = await this.$store.dispatch(
        "elixioConnectModule/printShipmentLabel",
        {
          shipmentId: this.shipment.id,
          labelType: this.labelType,
        }
      );
      this.$emit("updated");
    },

    openLabelLink(url) {
      window.open(url, "_blank");
    },

    async onPickupSubmitted() {
      this.showPickupForm = false;
      this.$emit("updated");
    },

    formatTime(timeObj) {
      if (!timeObj) return "-";
      const h = timeObj.hour.toString().padStart(2, "0");
      const m = timeObj.minute.toString().padStart(2, "0");
      return `${h}:${m}`;
    },
  },
};
</script>

<style scoped>
.shipment-item {
  border: 1px solid #ddd;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 10px;
}
.actions {
  margin-top: 10px;
  display: flex;
  gap: 8px;
}
.pickup-form-wrapper {
  margin-top: 15px;
  padding: 10px;
  background: #fafafa;
  border-radius: 8px;
}
.doc-icon {
  font-size: 25px;
}
.pickup-details {
  margin-top: 10px;
}
.border {
  border-radius: 8px;
  padding: 10px;
}
</style>
